// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.thema-line {
    display: flex;
    align-items: center;

    width: 100%;
    height: 28px;

    box-sizing: border-box;
    gap: 8px;
}
.thema-line + .thema-line {
    margin-top: 2px;
}

/* ==============================
   Image
   ============================== */

.thema-line-image {
    margin-top: 4px;
    width: 28px;
    height: 28px;

    flex: 0 0 40px;

    display: flex;
    align-items: center;
    justify-content: center;
}

.thema-line-image img {
    width: 28px;
    height: 28px;

    object-fit: contain;
}


/* ==============================
   Combobox
   ============================== */

.thema-line-combobox {
    flex: 1 1;
    min-width: 0;
}


/* ==============================
   Confidence
   ============================== */

.thema-line-confidence {
    width: 35px;
    height: 22px;
    margin-top: 4px;
    flex: 0 0 35px;

    text-align: center;

    font-size: 12px;
}


/* ==============================
   Delete
   ============================== */

.thema-line-delete {
    width: 24px;
    height: 28px;

    flex: 0 0 30px;

    padding: 0;

    border: none;
    background: transparent;
    color: #ff3030;
    font-size: 22px;
    font-weight: bold;
    line-height: 30px;

    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/themaline.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;;IAEnB,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;AACnB;;AAEA;;mCAEmC;;AAEnC;IACI,eAAe;IACf,WAAW;IACX,YAAY;;IAEZ,cAAc;;IAEd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;;IAEZ,mBAAmB;AACvB;;;AAGA;;mCAEmC;;AAEnC;IACI,SAAO;IACP,YAAY;AAChB;;;AAGA;;mCAEmC;;AAEnC;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;;IAEd,kBAAkB;;IAElB,eAAe;AACnB;;;AAGA;;mCAEmC;;AAEnC;IACI,WAAW;IACX,YAAY;;IAEZ,cAAc;;IAEd,UAAU;;IAEV,YAAY;IACZ,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;;IAEjB,eAAe;AACnB","sourcesContent":[".thema-line {\n    display: flex;\n    align-items: center;\n\n    width: 100%;\n    height: 28px;\n\n    box-sizing: border-box;\n    gap: 8px;\n}\n.thema-line + .thema-line {\n    margin-top: 2px;\n}\n\n/* ==============================\n   Image\n   ============================== */\n\n.thema-line-image {\n    margin-top: 4px;\n    width: 28px;\n    height: 28px;\n\n    flex: 0 0 40px;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.thema-line-image img {\n    width: 28px;\n    height: 28px;\n\n    object-fit: contain;\n}\n\n\n/* ==============================\n   Combobox\n   ============================== */\n\n.thema-line-combobox {\n    flex: 1;\n    min-width: 0;\n}\n\n\n/* ==============================\n   Confidence\n   ============================== */\n\n.thema-line-confidence {\n    width: 35px;\n    height: 22px;\n    margin-top: 4px;\n    flex: 0 0 35px;\n\n    text-align: center;\n\n    font-size: 12px;\n}\n\n\n/* ==============================\n   Delete\n   ============================== */\n\n.thema-line-delete {\n    width: 24px;\n    height: 28px;\n\n    flex: 0 0 30px;\n\n    padding: 0;\n\n    border: none;\n    background: transparent;\n    color: #ff3030;\n    font-size: 22px;\n    font-weight: bold;\n    line-height: 30px;\n\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
